/* Duma Premium – Interaktionen (Warenkorb, Mini-Warenkorb, Slider, Lieferdatum, Mengenstaffel, 3D-Kapsel-Loader) */
(function () {
  "use strict";
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function money(cents) {
    try {
      var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "CHF";
      return new Intl.NumberFormat("de-CH", { style: "currency", currency: cur }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  }
  function bus(name, data) { if (window.eventBus && window.eventBus.emit) window.eventBus.emit(name, data); }
  function getCart() { return fetch(root + "cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }); }

  /* ---------- In den Warenkorb (nutzt Flow-Warenkorb-Schublade) ---------- */
  window.dumaAddToCart = function (variantId, qty, btn) {
    if (!variantId) return Promise.resolve();
    if (btn) btn.setAttribute("disabled", "");
    /* Duma 20.10.: Warenkorb sofort öffnen (mit Ladebalken), wie beim Kauf-Knopf auf der Produktseite */
    var dmDr = document.querySelector("cart-drawer");
    if (dmDr && window.eventBus) { dmDr.classList.add("is-updating"); bus("open:cart:drawer", { scrollToTop: true }); }
    return fetch(root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(qty) || 1 }], sections: "cart-drawer" })
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (json && json.status && json.description) { alertInline(btn, json.description); return; }
        bus("update:cart:drawer", json);
        return getCart().then(function (cart) {
          if (window.wetheme && window.wetheme.updateCartCount) window.wetheme.updateCartCount(cart);
          bus("open:cart:drawer", { scrollToTop: true });
        });
      })
      .catch(function () { window.location.href = root + "cart"; })
      .finally(function () { if (btn) btn.removeAttribute("disabled"); if (dmDr) dmDr.classList.remove("is-updating"); });
  };
  function alertInline(btn, msg) {
    if (!btn) return;
    var old = btn.textContent; btn.textContent = msg; setTimeout(function () { btn.textContent = old; }, 3000);
  }

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-dm-scrolltop]")) { e.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); return; }
    var a = e.target.closest("[data-dm-add]");
    if (a) { e.preventDefault(); window.dumaAddToCart(a.getAttribute("data-dm-add"), a.getAttribute("data-dm-qty") || 1, a); return; }
    var q = e.target.closest("[data-dm-qv]");
    if (q) {
      e.preventDefault();
      /* Duma 13.10.: Handy → direkt zur Produktseite; Computer → Schnellansicht */
      /* 21.10.: nur Handy-Breite → Produktseite (vorher auch kleine Laptops/Touch-PCs) */
      var mob = window.matchMedia("(max-width:749px)").matches;
      if (!mob && window.wetheme && window.wetheme.toggleRightDrawer) {
        bus("close:all:drawers");
        window.wetheme.toggleRightDrawer("shop-now", true, { url: q.getAttribute("data-dm-qv") });
      } else { window.location.href = q.getAttribute("data-dm-qv"); }
    }
  });

  /* ---------- Mini-Warenkorb bei Mouseover ---------- */
  function setupMini() {
    if (!window.matchMedia("(hover:hover) and (min-width:981px)").matches) return;
    $$("[data-dm-cart], .site-header__cart-toggle").forEach(function (link) {
      var host = link.parentElement; if (!host || host.querySelector(".dm-mini")) return;
      if (getComputedStyle(host).position === "static") host.style.position = "relative";
      var box = document.createElement("div"); box.className = "dm-mini"; box.setAttribute("role", "dialog"); box.setAttribute("aria-label", "Warenkorb-Vorschau");
      host.appendChild(box);
      var t; var free = Number(document.documentElement.getAttribute("data-dm-free") || 9900);
      function render(cart) {
        var n = cart.item_count;
        var html = '<span class="dm-label">Warenkorb · ' + n + " Artikel</span>";
        if (!n) {
          html += '<p class="dm-mini__empty">Dein Warenkorb ist noch leer.</p>';
        } else {
          cart.items.slice(0, 3).forEach(function (it) {
            html += '<div class="dm-mini__row"><span class="dm-mini__t">' + (it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, "_120x$1$2") + '" alt="">' : "") + "</span><span>" + it.product_title + '<br><small style="color:#616665">' + it.quantity + " × " + money(it.final_price) + "</small></span><span>" + money(it.final_line_price) + "</span></div>";
          });
          if (cart.items.length > 3) html += '<p class="dm-mini__empty">+ ' + (cart.items.length - 3) + " weitere</p>";
          var left = free - cart.total_price, pct = Math.min(100, cart.total_price / free * 100);
          html += '<div class="dm-mini__sum"><span>Zwischensumme</span><span>' + money(cart.total_price) + "</span></div>";
          html += '<div class="dm-mini__ship">' + (left > 0 ? "Noch " + money(left) + " bis zum Gratisversand" : "Gratisversand freigeschaltet") + '<div class="dm-mini__track"><i style="width:' + pct + '%"></i></div></div>';
          html += '<div class="dm-mini__btns"><button type="button" class="dm-btn dm-btn--line" data-dm-open-cart>Warenkorb</button><a class="dm-btn dm-btn--solid" href="' + root + 'checkout">Zur Kasse</a></div>';
        }
        box.innerHTML = html;
      }
      function show() { clearTimeout(t); getCart().then(render).then(function () { box.classList.add("is-on"); }); }
      function hide() { t = setTimeout(function () { box.classList.remove("is-on"); }, 180); }
      link.addEventListener("mouseenter", show); link.addEventListener("mouseleave", hide);
      box.addEventListener("mouseenter", function () { clearTimeout(t); }); box.addEventListener("mouseleave", hide);
      box.addEventListener("click", function (e) { if (e.target.closest("[data-dm-open-cart]")) { box.classList.remove("is-on"); bus("open:cart:drawer"); } });
    });
  }

  /* ---------- Zitat-Slider ---------- */
  function setupQuotes() {
    $$("[data-dm-quotes]").forEach(function (el) {
      var items; try { items = JSON.parse(el.querySelector("script[type='application/json']").textContent); } catch (e) { return; }
      if (!items.length) return;
      var q = el.querySelector(".dm-quotes__q"), w = el.querySelector(".dm-quotes__who"), d = el.querySelector(".dm-quotes__dots"), i = 0;
      d.innerHTML = items.map(function () { return "<i></i>"; }).join("");
      function set(n) {
        i = (n + items.length) % items.length; q.style.opacity = 0;
        setTimeout(function () { q.textContent = "«" + items[i].q + "»"; w.textContent = items[i].w; q.style.opacity = 1; }, 110);
        $$("i", d).forEach(function (x, j) { x.classList.toggle("on", j === i); });
      }
      el.querySelector("[data-prev]").addEventListener("click", function () { set(i - 1); });
      el.querySelector("[data-next]").addEventListener("click", function () { set(i + 1); });
      /* 07.10.: Wischen auf dem Handy wechselt sofort (vorher reagierte nur der Pfeil) */
      var sx = null, sy = null;
      el.addEventListener("touchstart", function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; }, { passive: true });
      el.addEventListener("touchend", function (e) { if (sx === null) return; var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy; if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy)) { set(dx < 0 ? i + 1 : i - 1); restart(); } sx = null; }, { passive: true });
      var iv; function restart() { clearInterval(iv); iv = setInterval(function () { if (!document.hidden) set(i + 1); }, 7000); }
      set(0); restart();
    });
  }

  /* ---------- Voraussichtliches Lieferdatum ---------- */
  function setupDelivery() {
    $$("[data-dm-deliv]").forEach(function (el) {
      var a = Number(el.getAttribute("data-min") || 2), b = Number(el.getAttribute("data-max") || 3);
      function add(n) { var d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
      /* Duma 20.10.: kurz, damit es am Handy auf eine Zeile passt: «Do. 22. – Fr. 23. Okt.» */
      function wd(d) { var w = d.toLocaleDateString("de-CH", { weekday: "short" }); return /\.$/.test(w) ? w : w + "."; }
      function mo(d) { return d.toLocaleDateString("de-CH", { month: "short" }); }
      var x = add(a), y = add(b);
      el.textContent = x.getMonth() === y.getMonth() ? wd(x) + " " + x.getDate() + ". – " + wd(y) + " " + y.getDate() + ". " + mo(y) : wd(x) + " " + x.getDate() + ". " + mo(x) + " – " + wd(y) + " " + y.getDate() + ". " + mo(y);
    });
  }


  /* ---------- Vorbestellung: Button-Text + Vermerk ---------- */
  /* Duma 09.10.: nur das Kaufformular des Vorbestell-Produkts selbst (Produktseite / Schnellansicht).
     Vorschläge im Warenkorb bringen ihren eigenen Vermerk pro Produkt mit (product-card-basic). */
  function setupPreorder() {
    if (!document.querySelector("[data-dm-preorder]")) return;
    function apply() {
      $$("[data-dm-preorder]").forEach(function (el) {
        var box = el;
        while (box && box !== document.body && !box.querySelector('form[action*="/cart/add"]')) box = box.parentElement;
        if (!box || box === document.body) return;
        var val = el.getAttribute("data-dm-preorder") || "Ja";
        $$('form[action*="/cart/add"]', box).forEach(function (f) {
          if (f.id === "ProductCardBasicAtcForm" || f.closest("cart-drawer, .cart-drawer, .product-card-basic")) return;
          var pi = f.querySelector('input[name="properties[Vorbestellung]"]');
          if (!pi) { pi = document.createElement("input"); pi.type = "hidden"; pi.name = "properties[Vorbestellung]"; f.appendChild(pi); }
          pi.value = val;
          if (el.getAttribute("data-dm-pre-set")) return; /* Sets/Bundles: Knopf bleibt «In den Warenkorb», Vermerk reicht */
          $$('button[type="submit"], [name="add"]', f).forEach(function (b) {
            if (b.disabled) return;
            var t = b.querySelector(".button__text, span") || b;
            if (t.textContent.trim() && t.textContent.trim() !== "Vorbestellen") { t.textContent = "Vorbestellen"; }
          });
        });
      });
    }
    apply(); document.addEventListener("change", function () { setTimeout(apply, 120); });
  }


  /* ---------- Varianten: nur existierende Kombinationen zeigen (z. B. Swiss Whey 450 g nur Vanille/Schoggi) ---------- */
  function setupVariantFilter() {
    /* Duma 07.10: Alle Sorten bleiben sichtbar. Gibt es die gewählte Kombination nicht
       (z. B. Banane nur in 900 g), wird automatisch die passende Grösse gewählt.
       Grössen, die es für die gewählte Sorte nicht gibt, werden ausgeblendet. */
    var m = location.pathname.match(/\/products\/([^\/?#]+)/); if (!m) return;
    if (!document.querySelector('product-swatch[data-option-index="0"]')) return;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : "/") + "products/" + m[1] + ".js").then(function (r) { return r.json(); }).then(function (p) {
      if (!p.options || p.options.length < 2) return;
      function grp(k) { return document.querySelector('product-swatch[data-option-index="' + k + '"]'); }
      function selectedVal(k) { var g = grp(k); if (!g) return null; var on = g.querySelector("input:checked"); return on ? on.value : null; }
      function esc(v) { return String(v).replace(/\\/g, "\\\\").replace(/"/g, '\\"'); }
      document.addEventListener("change", function (e) {
        var inp = e.target; if (!inp || inp.type !== "radio") return;
        var sw = inp.closest && inp.closest("product-swatch[data-option-index]"); if (!sw) return;
        var js = sw.querySelector('script[type="application/json"][data-resource="' + inp.id + '"]');
        var v = null; try { v = js ? JSON.parse(js.textContent) : null; } catch (er) {}
        if (v) return;
        var idx = +sw.getAttribute("data-option-index"), sel = [];
        for (var k = 0; k < p.options.length; k++) sel[k] = k === idx ? inp.value : selectedVal(k);
        var best = null, bs = -1;
        p.variants.forEach(function (x) {
          if (x.options[idx] !== inp.value) return;
          var sc = (x.available ? 100 : 0); for (var k = 0; k < p.options.length; k++) if (x.options[k] === sel[k]) sc++;
          if (sc > bs) { bs = sc; best = x; }
        });
        if (!best || !window.eventBus) return;
        e.stopImmediatePropagation();
        var pu = inp.getAttribute("data-product-url") || ("/products/" + p.handle);
        eventBus.emit("variant:change", { sectionId: sw.getAttribute("data-section-id") || (sw.closest("product-information") || {}).dataset && sw.closest("product-information").dataset.sectionId, variant: best, fetchURL: pu + "?variant=" + best.id, productURL: pu, isCombinedListing: false });
      }, true);
      function update() {
        var c0 = selectedVal(0), hid = [];
        for (var k = 1; k < p.options.length; k++) {
          (p.options[k].values || []).forEach(function (val) {
            var ok = p.variants.some(function (v) { return v.options[0] === c0 && v.options[k] === val; });
            if (!ok) hid.push('product-swatch[data-option-index="' + k + '"] .swatch-element[data-value="' + esc(val) + '"]');
          });
        }
        var st = document.getElementById("dm-vhide-css"); if (!st) { st = document.createElement("style"); st.id = "dm-vhide-css"; document.head.appendChild(st); }
        var css = hid.length ? hid.join(",") + "{display:none!important}" : ""; if (st.textContent !== css) st.textContent = css;
      }
      document.addEventListener("change", function () { setTimeout(update, 0); });
      if (window.eventBus) eventBus.on("variant:updated", function () { setTimeout(update, 0); });
      update();
    }).catch(function () {});
  }


  /* ---------- Sicherheitsnetz: leerer Warenkorb-Button bekommt Text ---------- */
  function setupAtcText() {
    function fix() {
      $$('form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] [name="add"], #StickyMirrorBtn').forEach(function (b) {
        if (b.disabled) return;
        if (!b.textContent.trim()) { /* 21.10.: textContent statt innerText – sonst wurden Knöpfe im geschlossenen Warenkorb-Fenster überschrieben */ var t = b.querySelector("[data-add-to-cart-text]"); if (t) { t.style.display = ""; var pf = b.closest("form"); var pv = pf && pf.querySelector('input[name="properties[Vorbestellung]"]'); t.textContent = (pv && !/^Enthält/.test(pv.value)) ? "Vorbestellen" : "In den Warenkorb"; } else { b.textContent = "In den Warenkorb"; } }
      });
    }
    fix(); setInterval(fix, 1500);
  }


  /* ---------- Hero-Slides (Startseite: Slide 2 Shop-Launch) ---------- */
  function setupHeroSlides() {
    $$("[data-dm-hslides]").forEach(function (h) {
      if (h._dm) return; h._dm = 1;
      var dots = $$(".dm-hero__dots button", h), slides = $$(".dm-hero__s2", h), n = slides.length + 1, cur = 0, dur = 7000, t;
      h.style.setProperty("--dm-hdur", dur / 1000 + "s");
      function next() { go((cur + 1) % n); }
      function go(i) {
        cur = i; h.classList.toggle("is-s2", i > 0);
        slides.forEach(function (s) { s.classList.toggle("is-on", Number(s.getAttribute("data-slide")) === i); });
        var lt = slides.some(function (s) { return s.classList.contains("is-on") && s.classList.contains("dm-hero__s2--light"); }); document.documentElement.classList.toggle("dm-hero-light", lt);
        dots.forEach(function (d, k) { d.classList.remove("is-on"); void d.offsetWidth; d.classList.toggle("is-on", k === i); });
        clearTimeout(t); t = setTimeout(next, dur);
      }
      dots.forEach(function (d, k) { d.addEventListener("click", function () { go(k); }); });
      var x0 = null; h.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      h.addEventListener("touchend", function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 50) go(dx < 0 ? (cur + 1) % n : (cur - 1 + n) % n); x0 = null; }, { passive: true });
      var dmStart = slides.filter(function (s) { return s.classList.contains("dm-hero__s2--crx"); })[0]; /* 21.10.: Creatine-Folie zuerst */
      go(dmStart ? Number(dmStart.getAttribute("data-slide")) : 0);
    });
  }


  /* ---------- #naehrwerte: Nährwerte aufklappen und hinscrollen ---------- */
  function setupNutrHash() {
    var hid = location.hash.slice(1); if (hid !== "naehrwerte" && hid !== "hinweis") return;
    setTimeout(function () { var d = document.getElementById(hid); if (d) { d.open = true; d.scrollIntoView({ behavior: "smooth", block: "start" }); } }, 600);
  }

  /* ---------- Mengenstaffel (setzt Flow-Mengenfeld) ---------- */
  function setupPacks() {
    $$("[data-dm-packs]").forEach(function (box) {
      if (box._dm) return; box._dm = 1;
      var section = box.closest("product-information") || box.closest(".shopify-section") || document;
      function qtyInput() { return section.querySelector('input[name="quantity"]'); }
      function setQty(n) {
        var inp = qtyInput();
        if (inp) { inp.value = n; inp.dispatchEvent(new Event("input", { bubbles: true })); inp.dispatchEvent(new Event("change", { bubbles: true })); }
        if (window.eventBus) bus("qty:change", { qty: Number(n) });
      }
      var more = box.querySelector("[data-qty-more]"); var num = more && more.querySelector("input"); var MN = num ? (parseInt(num.getAttribute("min"), 10) || 4) : 4;
      var opts = $$(".dm-packs__opt[data-qty]", box); if (more) opts.push(more);
      var tip = box.querySelector("[data-dm-tip]"); var country = (box.getAttribute("data-dm-country") || "").toUpperCase();
      var curQty = 1;
      function refresh() {
        if (tip) { var show = curQty === 3 && !(more && more.classList.contains("is-on")); if (tip.hidden === show) { tip.hidden = !show; if (show) { tip.classList.remove("is-in"); void tip.offsetWidth; tip.classList.add("is-in"); } } }
        var idEl = (section.querySelector('form[action*="/cart/add"] [name="id"]')); var price = idEl && map[idEl.value] ? map[idEl.value] : 0;
        opts.forEach(function (o) {
          var q = o === more ? Math.max(MN, parseInt(num.value, 10) || MN) : Number(o.getAttribute("data-qty"));
          var pill = o.querySelector("[data-dm-ship]"); if (pill) pill.hidden = !(price && (country === "CH" || country === "LI") && price * q >= 9900);
        });
      }
      function select(opt) {
        opts.forEach(function (o) { o.classList.toggle("is-on", o === opt); o.setAttribute("aria-checked", String(o === opt)); });
        curQty = opt === more ? Math.max(MN, parseInt(num.value, 10) || MN) : Number(opt.getAttribute("data-qty"));
        setQty(curQty); refresh();
      }
      opts.forEach(function (opt) {
        opt.addEventListener("click", function (e) { if (e.target.closest(".dm-packs__step") && opt.classList.contains("is-on")) return; select(opt); });
        opt.addEventListener("keydown", function (e) { if (e.target.tagName === "INPUT") return; if (e.key === "Enter" || e.key === " ") { e.preventDefault(); select(opt); } });
      });
      if (more) {
        $$("[data-step]", more).forEach(function (bt) {
          bt.addEventListener("click", function (e) {
            e.preventDefault(); e.stopPropagation();
            num.value = Math.min(99, Math.max(MN, (parseInt(num.value, 10) || MN) + Number(bt.getAttribute("data-step"))));
            select(more);
          });
        });
        num.addEventListener("click", function (e) { e.stopPropagation(); if (!more.classList.contains("is-on")) select(more); });
        num.addEventListener("change", function () { select(more); });
      }
      /* Preise bei Variantenwechsel nachführen */
      var map = {}; try { map = JSON.parse("{" + (box.getAttribute("data-dm-vprices") || "") + "}"); } catch (e) {}
      var form = section.querySelector('form[action*="/cart/add"]'); var last = null;
      function money(c) { var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || "CHF"; try { return new Intl.NumberFormat("de-CH", { style: "currency", currency: cur }).format(c / 100); } catch (e) { return cur + " " + (c / 100).toFixed(2); } }
      function sync() {
        var idEl = form && form.querySelector('[name="id"]'); var id = idEl && idEl.value;
        if (!id || id === last || !map[id]) return; last = id;
        $$("[data-dm-mult]", box).forEach(function (el) { el.textContent = money(map[id] * Number(el.getAttribute("data-dm-mult"))); });
        refresh();
      }
      if (form) { form.addEventListener("change", function () { setTimeout(sync, 60); }); if (window.eventBus) { eventBus.on("variant:change", function () { setTimeout(sync, 0); }); eventBus.on("variant:updated", function () { setTimeout(sync, 0); }); } setInterval(sync, 1500); }
      refresh();
    });
    /* Bild-Badges ins Galeriebild verschieben */
    $$("[data-dm-gtags]").forEach(function (t) {
      var sec = t.closest(".shopify-section") || document;
      var gs = $$(".product-media-slider", sec); if (!gs.length) gs = $$(".product-media-slider");
      if (!gs.length || gs[0].contains(t)) return;
      gs.forEach(function (g, i) { var el = i === 0 ? t : t.cloneNode(true); g.style.position = g.style.position || "relative"; g.appendChild(el); el.classList.add("is-placed"); });
      function vb() {
        var sel = sec.querySelector('form[action*="/cart/add"] [name="id"]'); var opt = sel && sel.options ? sel.options[sel.selectedIndex] : null;
        var txt = (opt ? opt.text : "") + " " + ($$(".product-form input[type=radio]:checked", sec).map(function (r) { return r.value; }).join(" "));
        $$("[data-dm-vbadge]").forEach(function (c) { c.hidden = txt.indexOf(c.getAttribute("data-dm-vbadge")) < 0; });
      }
      vb(); sec.addEventListener("change", function () { setTimeout(vb, 60); });
    });
  }

  /* ---------- 3D-Kapsel erst laden, wenn sie in die Nähe kommt ---------- */
  function setupCapsule() {
    var secs = $$("[data-dm-capsule]"); if (!secs.length) return;
    var loaded = false;
    function load() {
      if (loaded) return; loaded = true;
      var s1 = document.createElement("script"); s1.src = secs[0].getAttribute("data-three");
      s1.onload = function () { var s2 = document.createElement("script"); s2.src = secs[0].getAttribute("data-capsule-js"); document.head.appendChild(s2); };
      s1.onerror = function () { secs.forEach(function (s) { var fb = s.querySelector(".dm-cap__fb"); if (fb) fb.hidden = false; }); };
      document.head.appendChild(s1);
    }
    if (!("IntersectionObserver" in window)) { load(); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { load(); io.disconnect(); } }); }, { rootMargin: "1200px 0px" });
    secs.forEach(function (s) { io.observe(s); });
  }


  /* ---------- Warenkorb-Zähler im Duma-Header ---------- */
  function setCount(cart) { $$("[data-dm-cart-count]").forEach(function (el) { el.textContent = cart.item_count; el.hidden = !cart.item_count; }); }
  document.documentElement.addEventListener("wetheme-cart-update", function (e) { if (e.detail && e.detail.cart) setCount(e.detail.cart); });
  var _add = window.dumaAddToCart;
  window.dumaAddToCart = function (v, q, b) { return _add(v, q, b).then(function () { return getCart().then(setCount); }); };

  /* ---------- Header: transparent über Hero ---------- */
  function setupHeader() {
    var h = document.querySelector("[data-dm-header]"); if (!h) return;
    if (h.classList.contains("dm-hdr--overlay")) {
      var hero = document.querySelector(".dm-hero");
      var upd = function () { var lim = hero ? hero.offsetHeight - 120 : 80; h.classList.toggle("is-over", window.scrollY < lim && !h.matches(":hover") && !h.contains(document.activeElement)); };
      window.addEventListener("scroll", upd, { passive: true }); h.addEventListener("mouseenter", upd); h.addEventListener("mouseleave", upd); h.addEventListener("focusin", upd); h.addEventListener("focusout", function () { setTimeout(upd, 0); }); upd();
    }
    var cartBtn = h.querySelector("[data-dm-cart]");
    if (cartBtn) cartBtn.addEventListener("click", function (e) { if (window.eventBus && document.querySelector("#CartDrawer, cart-drawer, [data-cart-drawer]")) { e.preventDefault(); bus("open:cart:drawer", { scrollToTop: true }); } });
    var mk = h.querySelector("[data-dm-mkt]");
    if (mk) { var list = mk.parentElement.querySelector(".dm-mkt__list");
      mk.addEventListener("click", function (e) { e.stopPropagation(); list.hidden = !list.hidden; mk.setAttribute("aria-expanded", String(!list.hidden)); });
      document.addEventListener("click", function (e) { if (!e.target.closest(".dm-mkt")) { list.hidden = true; mk.setAttribute("aria-expanded", "false"); } }); }
  }

  /* ---------- Drawer, Suche ---------- */
  var scrim;
  function closeAll() { $$(".dm-drawer.on, .dm-search.on").forEach(function (x) { x.classList.remove("on"); x.setAttribute("aria-hidden", "true"); }); if (scrim) scrim.classList.remove("on"); document.documentElement.style.overflow = ""; }
  function openEl(el) { closeAll(); el.classList.add("on"); el.setAttribute("aria-hidden", "false"); if (scrim) scrim.classList.add("on"); if (el.classList.contains("dm-drawer")) document.documentElement.style.overflow = "hidden"; }
  function setupDrawers() {
    scrim = document.querySelector("[data-dm-scrim]");
    document.addEventListener("click", function (e) {
      var o = e.target.closest("[data-dm-open]");
      if (o) { var el = document.getElementById(o.getAttribute("data-dm-open")); if (el) { e.preventDefault(); openEl(el); if (el.id === "dmSearch") { var i = el.querySelector("[data-dm-search-in]"); setTimeout(function () { i && i.focus(); }, 250); runSearch(""); } } return; }
      if (e.target.closest("[data-dm-close]") || e.target.closest("[data-dm-scrim]")) closeAll();
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeAll(); });
    var inp = document.querySelector("[data-dm-search-in]"); var t;
    if (inp) inp.addEventListener("input", function () { clearTimeout(t); t = setTimeout(function () { runSearch(inp.value); }, 180); });
    $$("[data-dm-term]").forEach(function (b) { b.addEventListener("click", function () { if (inp) { inp.value = b.getAttribute("data-dm-term"); runSearch(inp.value); } }); });
  }
  var searchSeq = 0;
  function runSearch(q) {
    var box = document.querySelector("[data-dm-search-res]"); if (!box) return;
    q = (q || "").trim();
    var url = q ? root + "search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last"
                : root + "search/suggest.json?q=duma&resources[type]=product&resources[limit]=4";
    var my = ++searchSeq;
    fetch(url).then(function (r) { return r.json(); }).then(function (j) {
      if (my !== searchSeq) return;
      var ps = (j.resources && j.resources.results && j.resources.results.products) || [];
      if (!ps.length) { box.innerHTML = '<p style="color:#616665">Keine Treffer für «' + q.replace(/</g, "&lt;") + '».</p>'; return; }
      box.innerHTML = ps.map(function (p) {
        var img = p.image ? '<img src="' + p.image + (p.image.indexOf("?") > -1 ? "&" : "?") + 'width=300" alt="" loading="lazy">' : "";
        return '<a href="' + p.url + '"><span class="dm-mega__t">' + img + "</span>" + p.title + "<small>" + (p.price ? money(Math.round(parseFloat(p.price) * 100)) : "") + "</small></a>";
      }).join("") + (q ? '<a class="dm-link dm-search__all" href="' + root + "search?type=product&q=" + encodeURIComponent(q) + '">Alle Ergebnisse</a>' : "");
    }).catch(function () {});
  }

  /* ---------- Ansagezeile ---------- */
  function setupAnn() {
    $$("[data-dm-ann]").forEach(function (a) {
      var msgs = $$(".dm-ann__msg", a), i = 0; if (msgs.length < 2) { $$(".dm-ann__arr", a).forEach(function (b) { b.hidden = true; }); return; }
      var sp = Number(a.getAttribute("data-speed")) || 5000, t;
      function set(n) { msgs[i].classList.remove("on"); i = (n + msgs.length) % msgs.length; msgs[i].classList.add("on"); }
      function go() { clearInterval(t); t = setInterval(function () { set(i + 1); }, sp); }
      a.querySelector("[data-prev]").addEventListener("click", function () { set(i - 1); go(); });
      a.querySelector("[data-next]").addEventListener("click", function () { set(i + 1); go(); });
      go();
    });
  }

  /* ---------- Bewertungs-Reiter ausblenden, solange die 3D-Kapsel läuft ---------- */
  function setupRtab() {
    var tab = document.querySelector(".dm-rtab"), cap = document.querySelector(".dm-cap__stick");
    if (!tab || !cap || !("IntersectionObserver" in window)) return;
    new IntersectionObserver(function (es) { tab.classList.toggle("is-hidden", es[0].isIntersecting); }, { threshold: .2 }).observe(cap);
  }

  /* ---------- Empfehlungen nachladen ---------- */
  function setupRecs() {
    $$("[data-dm-recs]").forEach(function (el) {
      if (el.__done) return; el.__done = true;
      fetch(el.getAttribute("data-url")).then(function (r) { return r.text(); }).then(function (html) {
        var d = document.createElement("div"); d.innerHTML = html;
        var inner = d.querySelector("[data-dm-recs]");
        if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML; else if (!el.innerHTML.trim() && el.closest("section")) el.closest("section").hidden = true;
      }).catch(function () {});
    });
  }


  /* ---------- Bewertungen: Slider aus Judge.me-Daten ---------- */
  function setupRevs() {
    $$("[data-dm-revs]").forEach(function (sec) {
      if (sec.__rv) return; sec.__rv = true;
      var pid = sec.getAttribute("data-dm-revs"), tries = 0;
      function esc(t) { var d = document.createElement("div"); d.textContent = t || ""; return d.innerHTML; }
      function stars(n) { n = Math.round(n || 0); return "★★★★★".slice(0, n) + '<span class="dm-revs__off">' + "★★★★★".slice(0, 5 - n) + "</span>"; }
      function build(data) {
        var list = (data.reviews || []).filter(function (x) { return x.body && x.rating >= 3 && !x.hidden; });
        if (!list.length) return;
        list.sort(function (a, b) { return (b.rating - a.rating) || (b.body.length > 20) - (a.body.length > 20); });
        var track = sec.querySelector("[data-rv-track]");
        track.innerHTML = list.map(function (x) {
          var body = x.body.replace(/\s+/g, " ").trim(), long = body.length > 260;
          return '<article class="dm-revs__card"><span class="dm-stars">' + stars(x.rating) + "</span>" +
            (x.title ? '<h3>' + esc(x.title) + "</h3>" : "") +
            '<p' + (long ? ' class="is-long"' : "") + '>«' + esc(body) + '»</p>' +
            (long ? '<button type="button" class="dm-revs__more">Weiterlesen</button>' : "") +
            '<div class="dm-revs__by">' + esc(x.reviewer_name || "Kundin/Kunde") + (x.verified_buyer ? " · verifizierter Kauf" : "") + "</div></article>";
        }).join("");
        var avg = parseFloat(data.average_rating), cnt = data.number_of_reviews;
        if (avg) { sec.querySelector("[data-rv-avg]").textContent = avg.toFixed(1); sec.querySelector(".dm-revs__score").hidden = false; }
        if (cnt) sec.querySelector("[data-rv-count]").textContent = cnt + (Number(cnt) === 1 ? " verifizierte Bewertung" : " verifizierte Bewertungen");
        if (data.histogram) sec.querySelector("[data-rv-dist]").innerHTML = data.histogram.map(function (h) {
          return '<div><span>' + h.rating + '</span><i><b style="width:' + (h.percentage || 0) + '%"></b></i><span class="dm-tnum">' + (h.frequency || 0) + "</span></div>";
        }).join("");
        sec.querySelector("[data-rv-slider]").hidden = false;
        sec.classList.add("dm-revs--custom");
        var all = sec.querySelector("[data-rv-all]"); all.hidden = false;
        all.addEventListener("click", function () {
          var open = sec.classList.toggle("dm-revs--open");
          all.textContent = open ? "Bewertungen ausblenden" : "Alle Bewertungen & schreiben";
          if (open) sec.querySelector("[data-rv-app]").scrollIntoView({ behavior: "smooth", block: "start" });
        });
        track.addEventListener("click", function (e) {
          var b = e.target.closest(".dm-revs__more"); if (!b) return;
          var p = b.previousElementSibling; p.classList.toggle("is-open"); b.textContent = p.classList.contains("is-open") ? "Weniger" : "Weiterlesen";
        });
        var pos = sec.querySelector("[data-rv-pos]"), cards = track.children;
        function step() { return cards[0] ? cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : 300; }
        function upd() {
          var per = Math.max(1, Math.round(track.clientWidth / step())), i = Math.round(track.scrollLeft / step());
          pos.textContent = String(Math.min(cards.length, i + per)).padStart(2, "0") + " / " + String(cards.length).padStart(2, "0");
          sec.querySelector("[data-rv-prev]").disabled = track.scrollLeft < 4;
          sec.querySelector("[data-rv-next]").disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        }
        sec.querySelector("[data-rv-prev]").addEventListener("click", function () { track.scrollBy({ left: -step(), behavior: "smooth" }); });
        sec.querySelector("[data-rv-next]").addEventListener("click", function () { track.scrollBy({ left: step(), behavior: "smooth" }); });
        track.addEventListener("scroll", function () { requestAnimationFrame(upd); }, { passive: true });
        window.addEventListener("resize", upd); upd();
      }
      (function poll() {
        var d = window.jdgm && jdgm.data && jdgm.data.reviewWidget && jdgm.data.reviewWidget[pid];
        if (d) return build(d);
        if (++tries < 40) setTimeout(poll, 250);
      })();
    });
  }

  /* ---------- Produktlinien Tabs ---------- */
  function setupLines() {
    $$("[data-dm-lines]").forEach(function (sec) {
      if (sec.__ln) return; sec.__ln = true;
      var tabs = sec.querySelectorAll("[data-line-tab]"), panels = sec.querySelectorAll("[data-line-panel]");
      /* 07.10.: Bilder der zweiten Linie vorladen, sobald der Abschnitt näher kommt – Umschalten ohne Warten */
      function warm() { sec.querySelectorAll("[data-line-panel] img").forEach(function (im) { im.loading = "eager"; if (im.decode) im.decode().catch(function () {}); }); }
      if ("IntersectionObserver" in window) { var io = new IntersectionObserver(function (en) { if (en.some(function (x) { return x.isIntersecting; })) { warm(); io.disconnect(); } }, { rootMargin: "800px 0px" }); io.observe(sec); } else warm();
      tabs.forEach(function (t) {
        t.addEventListener("click", function () {
          var i = t.getAttribute("data-line-tab");
          tabs.forEach(function (x) { var on = x === t; x.classList.toggle("is-on", on); x.setAttribute("aria-selected", on); });
          panels.forEach(function (p) { var on = p.getAttribute("data-line-panel") === i; p.hidden = !on; p.classList.toggle("is-on", on); });
        });
      });
    });
  }

  /* ---------- Selleasy-Popup auf Deutsch ---------- */
  function setupUpsellI18n() {
    var map = [
      [/^\s*You might also like these\s*$/i, "Passt perfekt dazu"],
      [/^\s*Frequently bought together\s*$/i, "Oft zusammen gekauft"],
      [/Limited time offer!\s*Expires in/i, "Nur vor dem Checkout: −10 % auf diese Ergänzungen. Endet in"],
      [/^\s*Add\s*$/i, "Hinzufügen"], [/^\s*Added\s*$/i, "✓ Hinzugefügt"], [/^\s*Adding\.*\s*$/i, "Wird hinzugefügt …"],
      [/^\s*Continue\s*$/i, "Weiter zur Kasse"], [/^\s*No,? thanks\s*$/i, "Nein, danke"], [/^\s*Checkout\s*$/i, "Zur Kasse"],
      [/^\s*Sold out\s*$/i, "Ausverkauft"], [/^\s*Total\s*$/i, "Total"], [/^\s*Add selected to cart\s*$/i, "Auswahl in den Warenkorb"]
    ];
    function tr(root) {
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n;
      while ((n = w.nextNode())) {
        var t = n.nodeValue; if (!t || !t.trim()) continue;
        for (var i = 0; i < map.length; i++) if (map[i][0].test(t)) { n.nodeValue = t.replace(map[i][0], map[i][1]); break; }
      }
    }
    var mo = new MutationObserver(function (ms) {
      ms.forEach(function (m) {
        m.addedNodes && m.addedNodes.forEach(function (a) {
          if (a.nodeType === 1 && (a.matches && (a.matches("[class*=lb-], lb-upsell-addon-popup") || a.querySelector("[class*=lb-]")))) tr(a);
          else if (a.nodeType === 3 && a.parentElement && a.parentElement.closest("[class*=lb-]")) tr(a.parentElement);
        });
        if (m.type === "characterData" && m.target.parentElement && m.target.parentElement.closest("[class*=lb-addon], [class*=lb-spc]")) tr(m.target.parentElement);
      });
    });
    mo.observe(document.body, { childList: true, subtree: true, characterData: true });
    $$("[class*=lb-addon-popup]").forEach(tr);
  }

  /* ---------- Produkt-Reveal ---------- */
  function setupReveal() {
    var secs = $$("[data-dm-reveal]"); if (!secs.length) return;
    var mq = window.matchMedia("(max-width: 860px)");
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    secs.forEach(function (sec) {
      if (sec.__rv2) return; sec.__rv2 = true;
      var cos = sec.querySelectorAll(".dm-rv__co"), end = sec.querySelector(".dm-rv__end"), n = cos.length, ticking = false;
      if (reduce) { cos.forEach(function (c) { c.classList.add("is-on"); }); end && end.classList.add("is-on"); return; }
      function clamp(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }
      function upd() {
        ticking = false;
        var r = sec.getBoundingClientRect(), total = sec.offsetHeight - innerHeight;
        var p = clamp(-r.top / (total || 1));
        var pin = clamp(p / .12), open = clamp((p - .1) / .22);
        sec.style.setProperty("--p", p.toFixed(4));
        sec.style.setProperty("--pin", pin.toFixed(4));
        sec.style.setProperty("--shift", mq.matches ? 0 : ((1 - pin) * 22).toFixed(2));
        sec.style.setProperty("--open", (open * (2 - open)).toFixed(4));
        var start = .26, span = .6, step = n ? span / n : 1, mobile = mq.matches;
        cos.forEach(function (c, i) {
          var a = start + i * step, b = a + step;
          var on = mobile ? (p >= a && (p < b || i === n - 1) && p < .9) : p >= a;
          c.classList.toggle("is-on", on);
          c.classList.toggle("is-past", mobile && p >= b && i !== n - 1);
        });
        end && end.classList.toggle("is-on", p > .88);
      }
      window.addEventListener("scroll", function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
      window.addEventListener("resize", upd);
      upd();
    });
  }

  /* ---------- 360°-Ansicht mit echten Etiketten + Herkunft ---------- */
  function setup360() {
    var root = document.querySelector("[data-dm360-root]"); if (!root || root.__done) return; root.__done = true;
    var el = root.querySelector("[data-dm360]"); if (!el) return;
    var cfg; try { cfg = JSON.parse(el.textContent); } catch (e) { return; }
    var title = root.getAttribute("data-title") || "";
    function esc(t) { var d = document.createElement("div"); d.textContent = t || ""; return d.innerHTML; }
    var pin = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.4"/></svg>';
    var rot = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 12a8 8 0 1 1-2.3-5.6"/><path d="M20 4v4h-4"/></svg>';
    function chips() {
      $$(".thumbnail-media--main-media").forEach(function (g) {
        if (g.__dmc) return; g.__dmc = true;
        var box = g; if (getComputedStyle(box).position === "static") box.style.position = "relative";
        var w = document.createElement("div"); w.className = "dm-360chips";
        w.innerHTML = (cfg.type ? '<button type="button" class="dm-360chip dm-360chip--go" data-dm360-open>' + rot + '<span><b>360°</b> Rundum ansehen</span></button>' : "") +
          (cfg.origin ? '<span class="dm-360chip dm-360chip--org">' + pin + '<span>' + esc(cfg.origin) + '</span></span>' : "");
        box.appendChild(w);
      });
    }
    chips(); setTimeout(chips, 1500); window.addEventListener("resize", chips);
    if (!cfg.type) return;

    var modal, viewer, libP;
    function loadScript(src) { return new Promise(function (res, rej) { var s = document.createElement("script"); s.src = src; s.onload = res; s.onerror = rej; document.head.appendChild(s); }); }
    function libs() {
      if (!libP) libP = (window.THREE ? Promise.resolve() : loadScript(root.getAttribute("data-three"))).then(function () { return window.DumaViewer360 ? null : loadScript(root.getAttribute("data-lib")); });
      return libP;
    }
    function model() {
      if (cfg.type !== "pouch") return { type: cfg.type, label: cfg.label, cap: cfg.cap };
      var idEl = document.querySelector('.product--add-to-cart-form [name="id"], form[action*="/cart/add"] [name="id"]');
      var key = (idEl && cfg.map[idEl.value]) || cfg.def, t = cfg.tex[key] || cfg.tex[cfg.def];
      return { type: "pouch", front: t.f, back: t.b, depth: cfg.depth };
    }
    function build() {
      modal = document.createElement("div"); modal.className = "dm dm-360m"; modal.setAttribute("role", "dialog"); modal.setAttribute("aria-modal", "true"); modal.setAttribute("aria-label", "360°-Ansicht " + title);
      var facts = (cfg.facts || []).map(function (f) { return "<div><dt>" + esc(f.k) + "</dt><dd>" + esc(f.v) + "</dd></div>"; }).join("");
      modal.innerHTML = '<div class="dm-360m__stage"><div class="dm-360m__host"></div><span class="dm-360m__hint">' + rot + ' Ziehen zum Drehen</span><span class="dm-360m__load">Etikett wird geladen …</span></div>' +
        '<aside class="dm-360m__info"><span class="dm-label">360° · Echtes Etikett</span><h3>' + esc(title) + '</h3>' +
        (cfg.origin ? '<p class="dm-origin">' + pin + '<span>Entwickelt in Liechtenstein · ' + esc(cfg.origin) + '</span></p>' : "") +
        '<dl class="dm-360m__facts">' + facts + '</dl><div class="dm-360m__btns"><button type="button" class="dm-btn dm-btn--line" data-dm360-spin>Einmal drehen</button><button type="button" class="dm-btn dm-btn--solid" data-dm360-close>Zurück zum Produkt</button></div></aside>' +
        '<button type="button" class="dm-360m__x" aria-label="Schliessen" data-dm360-close>×</button>';
      document.body.appendChild(modal);
      modal.addEventListener("click", function (e) {
        if (e.target === modal || e.target.closest("[data-dm360-close]")) close();
        if (e.target.closest("[data-dm360-spin]") && viewer) viewer.spin(.5);
      });
      document.addEventListener("keydown", function (e) { if (e.key === "Escape" && modal.classList.contains("is-on")) close(); });
    }
    function open() {
      if (!modal) build();
      modal.classList.add("is-on"); document.documentElement.classList.add("dm-lock");
      var host = modal.querySelector(".dm-360m__host");
      libs().then(function () {
        if (!viewer) viewer = new window.DumaViewer360(host, { start: -.5 });
        viewer.size(); return viewer.setModel(model());
      }).then(function () { modal.classList.add("is-ready"); }).catch(function () { modal.classList.add("is-fail"); });
    }
    function close() { modal.classList.remove("is-on"); document.documentElement.classList.remove("dm-lock"); }
    document.addEventListener("click", function (e) { if (e.target.closest("[data-dm360-open]")) { e.preventDefault(); open(); } });
  }

  /* Duma 13.10.: Schnellansicht – oberer Kaufknopf löst den echten Kaufknopf aus und zeigt dessen Text/Preis */
  function setupQvBar() {
    $$("[data-dm-qv-bar]").forEach(function (bar) {
      if (bar.getAttribute("data-dm-ok")) return; bar.setAttribute("data-dm-ok", "1");
      var root = bar.closest(".dm-qv"); if (!root) return;
      var btn = bar.querySelector("[data-dm-qv-atc]"), pr = bar.querySelector("[data-dm-qv-price]");
      function real() { return root.querySelector('form[action*="/cart/add"] [name="add"]'); }
      function sync() {
        var r = real(); if (!r) return;
        var t = ((r.innerText || "").split("\n").map(function (x) { return x.trim(); }).filter(Boolean)[0] || ""); t = t.charAt(0) + t.slice(1).toLowerCase().replace("warenkorb", "Warenkorb"); if (t && btn.textContent !== t) btn.textContent = t;
        btn.disabled = r.disabled;
        var p = root.querySelector(".product-single__price, [data-product-price], .price-item--sale, .price-item--regular, .product__price");
        if (p && pr) { var pt = (p.textContent || "").replace(/\s+/g, " ").trim(); if (pt && pt.length < 40 && pr.textContent !== pt) pr.textContent = pt; }
      }
      btn.addEventListener("click", function () { var r = real(); if (r && !r.disabled) r.click(); });
      var q = false; new MutationObserver(function () { if (q) return; q = true; requestAnimationFrame(function () { q = false; sync(); }); }).observe(root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ["disabled"] });
      sync();
    });
  }

  function init() { setupHeader(); setupDrawers(); setupAnn(); setupMini(); setupQuotes(); setupDelivery(); setupPreorder(); setupPacks(); setupVariantFilter(); setupAtcText(); setupHeroSlides(); setupNutrHash(); setupCapsule(); setupRtab(); setupRecs(); setupRevs(); setupLines(); setupUpsellI18n(); setupReveal(); setup360(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  document.addEventListener("shopify:section:load", function () { setupReveal(); setupLines(); setupQuotes(); setupDelivery(); setupPacks(); setupCapsule(); });
  /* Duma 07.10. (2): Schnellansicht (Auge / «Sorte wählen») – Mengenwahl, Lieferzeile und Vorbestellung auch dort aktiv */
  window.dmReinitProduct = function () { try { setupDelivery(); setupPreorder(); setupPacks(); setupQvBar(); } catch (e) {}
    /* Schnellansicht: Galerie-Bilder sofort laden, sonst bleiben beim Wischen (iPhone) leere Bilder */
    document.querySelectorAll('product-information[data-quick-view="true"]').forEach(function (pi) { var root = pi.closest('.product-single, .product-section') || pi.parentElement || pi; root.querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; }); });
  };
  (function () {
    var tries = 0, t = null;
    function poll() { clearInterval(t); tries = 0; t = setInterval(function () { tries++; if (document.querySelector("[data-dm-packs]:not([data-dm-ok]), product-information[data-quick-view=\"true\"]:not([data-dm-ok])")) { document.querySelectorAll('product-information[data-quick-view="true"]').forEach(function (q) { q.setAttribute("data-dm-ok", "1"); }); document.querySelectorAll("[data-dm-packs]").forEach(function (b) { b.setAttribute("data-dm-ok", "1"); }); window.dmReinitProduct(); } if (tries > 30) clearInterval(t); }, 200); }
    if (window.eventBus) { eventBus.on("toggle:right:drawer", poll); }
    document.addEventListener("click", function (e) { if (e.target.closest && e.target.closest("[data-dm-qv]")) poll(); }, true);
    document.querySelectorAll("[data-dm-packs]").forEach(function (b) { b.setAttribute("data-dm-ok", "1"); });
  })();
})();
/* Varianten-Badges (z. B. «Hergestellt in der Schweiz» nur bei 450 g) */
(function(){
  function sel(){
    var vs=(window.ShopifyAnalytics&&ShopifyAnalytics.meta&&ShopifyAnalytics.meta.product&&ShopifyAnalytics.meta.product.variants)||[];
    var id=new URLSearchParams(location.search).get('variant');
    if(!id){var ins=document.querySelectorAll('form[action*="/cart/add"] [name="id"]');for(var i=0;i<ins.length;i++){if(ins[i].value&&vs.some(function(v){return String(v.id)===String(ins[i].value)})){id=ins[i].value;break}}}
    if(!id&&vs[0])id=vs[0].id;
    var v=vs.filter(function(x){return String(x.id)===String(id)})[0];
    return v?(v.public_title||v.name||''):'';
  }
  function run(){var s=sel(); if(!s) return; /* 20.10.: ohne Variantendaten (z. B. Schnellansicht) bleibt die Anzeige vom Server */ document.querySelectorAll('[data-dm-vbadge]').forEach(function(b){var m=b.getAttribute('data-dm-vbadge'); b.hidden = s.replace(/\s/g,'').indexOf(m)===-1;});}
  document.addEventListener('change',function(){setTimeout(run,80);setTimeout(run,400)});document.addEventListener('click',function(e){if(e.target.closest('label,button,[data-value]'))setTimeout(run,400)});
  document.addEventListener('DOMContentLoaded',function(){if(document.querySelector('[data-dm-vbadge]')){setTimeout(run,300);var last=location.search;setInterval(function(){if(location.search!==last){last=location.search;run()}},400)}});
})();

/* 03.10. «Mehr lesen» für gekürzte Produkt-Intros (mobil) */
(function(){
  function init(){
    var dmMob=window.matchMedia('(max-width:749px)').matches;
    document.querySelectorAll(dmMob?'.dm-buy-intro__lede':'.dm-intro-wrap--clamp .dm-buy-intro__lede').forEach(function(p){
      if(p.dataset.dmMore) return; p.dataset.dmMore='1';
      var box=p.closest('.dm-buy-intro'), mix=box&&box.querySelector('.dm-buy-intro__mix');
      if(!dmMob) mix=null;
      if(p.scrollHeight <= p.clientHeight + 2 && !mix){ if(!dmMob){ var w=p.closest('.dm-intro-wrap'); if(w) w.classList.add('dm-intro-wrap--off'); } return; }
      var b=document.createElement('button'); b.type='button'; b.className='dm-buy-intro__more'; b.textContent='Mehr lesen';
      b.addEventListener('click',function(){ var o=p.classList.toggle('is-open'); if(box) box.classList.toggle('is-open',o); b.textContent=o?'Weniger':'Mehr lesen'; });
      (mix||p).insertAdjacentElement('afterend',b);
    });
    if(!dmMob) return;
    document.querySelectorAll('.dm-flist, .dm-in__grid, .dm-bdl__grid').forEach(function(l){
      if(l.dataset.dmHint || l.children.length<2) return; l.dataset.dmHint='1';
      var h=document.createElement('span'); h.className='dm-swipe-hint'; h.textContent='Wischen für mehr →'; l.insertAdjacentElement('afterend',h);
    });
  }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded',init);
  window.addEventListener('load',init);
})();
/* 03.10. Über uns: Wisch-Hinweis Team Duma (Handy) */
(function(){function i(){if(!window.matchMedia('(max-width:749px)').matches)return;document.querySelectorAll('.dm-ath__grid').forEach(function(g){if(g.dataset.dmHint||g.children.length<2)return;g.dataset.dmHint='1';var h=document.createElement('span');h.className='dm-swipe-hint';h.textContent='Wischen für mehr →';g.insertAdjacentElement('afterend',h);});}
if(document.readyState!=='loading')i();else document.addEventListener('DOMContentLoaded',i);})();
/* 03.10. Handy, ab 20.10. auch PC: Fragen nach 5 einklappen */
(function(){function i(){
 document.querySelectorAll('section.dm-faq').forEach(function(s){if(s.dataset.dmMore)return;var ds=s.querySelectorAll('details');if(ds.length<=5)return;s.dataset.dmMore='1';
  var rest=ds.length-5;for(var k=5;k<ds.length;k++)ds[k].classList.add('dm-faq--more');
  var b=document.createElement('button');b.type='button';b.className='dm-faq__toggle';var lbl='Weitere Fragen anzeigen';b.textContent=lbl;
  b.addEventListener('click',function(){var o=s.classList.toggle('is-all');b.textContent=o?'Weniger anzeigen':lbl;if(!o)s.scrollIntoView({block:'start'});});
  ds[ds.length-1].insertAdjacentElement('afterend',b);});}
if(document.readyState!=='loading')i();else document.addEventListener('DOMContentLoaded',i);})();
/* 07.10. Spar-Tipp 3er-Pack: legt den 3er-Pack (gleiche Sorte) direkt in den Warenkorb und öffnet ihn, statt auf die 3er-Pack-Seite zu wechseln */
(function(){
  document.addEventListener('click', function (e) {
    var tip = e.target.closest && e.target.closest('a[data-dm-tip]'); if (!tip) return;
    e.preventDefault(); if (tip.classList.contains('is-busy')) return;
    var url = tip.getAttribute('href').split('?')[0];
    var cta = tip.querySelector('.dm-packs__tip-cta'); var old = cta ? cta.textContent : '';
    tip.classList.add('is-busy'); if (cta) cta.textContent = 'Wird hinzugefügt …';
    function fallback() { window.location.href = url; }
    fetch(url + '.js').then(function (r) { return r.json(); }).then(function (pk) {
      var sec = tip.closest('.shopify-section') || document;
      var idEl = sec.querySelector('form[action*="/cart/add"] [name="id"]');
      var vs = (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product && ShopifyAnalytics.meta.product.variants) || [];
      var cur = vs.filter(function (v) { return idEl && String(v.id) === String(idEl.value); })[0];
      var flav = cur ? String(cur.public_title || '').split(' / ')[0].trim() : '';
      var av = (pk.variants || []).filter(function (v) { return v.available; });
      var pick = av.length === 1 ? av[0] : av.filter(function (v) { return flav && String(v.title || '').split(' / ')[0].trim() === flav; })[0];
      if (!pick) { fallback(); return null; }
      return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: pick.id, quantity: 1 }], sections: 'cart-drawer' }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (j) {
          if (window.eventBus) window.eventBus.emit('update:cart:drawer', j);
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            if (window.eventBus) window.eventBus.emit('open:cart:drawer', { scrollToTop: true });
            if (window.wetheme && window.wetheme.updateCartCount) window.wetheme.updateCartCount(cart);
            if (cta) cta.textContent = 'Im Warenkorb ✓';
            setTimeout(function () { if (cta) cta.textContent = old; }, 2500);
          });
        });
    }).catch(fallback).then(function () { tip.classList.remove('is-busy'); });
  }, true);
})();
/* 07.10. Animationen im Abschnitt «Blick hinein» nur laufen lassen, solange er im Bild ist */
(function(){
  function go(){ var els=document.querySelectorAll('[data-dm-reveal]'); if(!els.length||!('IntersectionObserver' in window)) { els.forEach(function(e){e.classList.add('dm-inview')}); return; }
    var io=new IntersectionObserver(function(en){ en.forEach(function(x){ x.target.classList.toggle('dm-inview', x.isIntersecting); }); },{rootMargin:'100px 0px'});
    els.forEach(function(e){ io.observe(e); }); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',go); else go();
})();

/* Duma 07.10: Kategorien/Themen ohne Neuladen wechseln (Alle Produkte, Kategorien, Wissen).
   Lädt nur die betroffenen Bereiche (Section Rendering), hält die Position der Kategorie-Leiste,
   lädt alle Kategorien im Leerlauf vor. Bei Fehler: normaler Seitenwechsel. */
(function(){
  if(!window.fetch||!window.history||!history.pushState) return;
  var cache={};
  function secOf(el){ var s=el&&el.closest('[id^="shopify-section-"]'); return s?s.id.replace('shopify-section-',''):null; }
  function groups(){
    var out=[];
    var chips=document.querySelector('.dm-colhero2__chips');
    var grid=document.getElementById('CollectionProductGrid');
    if(chips&&grid){ var a=secOf(chips), b=secOf(grid); if(a&&b) out.push({bar:'.dm-colhero2__chips', ids:[a,b]}); }
    var tags=document.querySelector('.dm-blog__tags');
    if(tags){ var c=secOf(tags); if(c) out.push({bar:'.dm-blog__tags', ids:[c]}); }
    return out;
  }
  function key(href,ids){ var u=new URL(href,location.href); u.hash=''; return u.pathname+u.search+'|'+ids.join(','); }
  function load(href,ids){
    var k=key(href,ids); if(cache[k]) return cache[k];
    var u=new URL(href,location.href); u.hash=''; u.searchParams.set('sections',ids.join(','));
    cache[k]=fetch(u.toString(),{credentials:'same-origin'}).then(function(r){ if(!r.ok) throw 0; return r.json(); }).then(function(j){
      ids.forEach(function(id){ if(!j[id]) throw 0; }); return j;
    }).catch(function(e){ delete cache[k]; throw e; });
    return cache[k];
  }
  function preloadImg(html){
    return new Promise(function(res){
      var m=html.match(/<img[^>]+>/); if(!m) return res();
      var t=document.createElement('div'); t.innerHTML=m[0]; var im=t.firstChild; if(!im||im.loading==='lazy') return res();
      var p=new Image(); if(im.sizes) p.sizes=im.sizes; if(im.srcset) p.srcset=im.srcset; p.src=im.getAttribute('src');
      var done=false; function f(){ if(!done){done=true;res();} }
      (p.decode?p.decode():Promise.reject()).then(f,f); setTimeout(f,350);
    });
  }
  function swap(g,j,href,push){
    var barOld=document.querySelector(g.bar), sl=barOld?barOld.scrollLeft:0;
    /* Filter-Komponente der Vorlage: doppelte Fenster-Listener beim Neuaufbau vermeiden */
    var add=window.addEventListener;
    window.addEventListener=function(t){ if(t==='popstate'||t==='resize') return; return add.apply(window,arguments); };
    try{
      g.ids.forEach(function(id){
        var el=document.getElementById('shopify-section-'+id); if(!el) return;
        var t=document.createElement('div'); t.innerHTML=j[id];
        var n=t.querySelector('#shopify-section-'+id)||t;
        el.innerHTML=n.innerHTML;
      });
    } finally { window.addEventListener=add; }
    var bar=document.querySelector(g.bar);
    if(bar){ bar.scrollLeft=sl; var on=bar.querySelector('.is-on'); if(on&&bar.scrollWidth>bar.clientWidth){ var l=bar.scrollLeft+(on.getBoundingClientRect().left-bar.getBoundingClientRect().left)-(bar.clientWidth-on.offsetWidth)/2; bar.scrollLeft=Math.max(0,l); } }
    var h1=document.querySelector('.dm-colhero2 h1'); 
    if(h1){ var tt=(h1.childNodes[0]&&h1.childNodes[0].textContent||'').trim(); if(tt) document.title=tt+' – Duma Nutrition'; }
    if(push){ var u=new URL(href,location.href); u.hash=''; history.pushState({dmsoft:1},'',u.pathname+u.search); }
    document.dispatchEvent(new CustomEvent('paginate'));
    document.dispatchEvent(new CustomEvent('dm:softnav'));
  }
  function bind(){
    groups().forEach(function(g){
      var bar=document.querySelector(g.bar); if(!bar||bar.__dmsoft) return;
      var sec=document.getElementById('shopify-section-'+g.ids[0]);
      if(sec.__dmsoft) return; sec.__dmsoft=1;
      var on0=bar.querySelector('.is-on'); if(on0&&bar.scrollWidth>bar.clientWidth){ bar.scrollLeft=Math.max(0,(on0.getBoundingClientRect().left-bar.getBoundingClientRect().left)-(bar.clientWidth-on0.offsetWidth)/2); }
      var warm=function(e){ var a=e.target.closest&&e.target.closest(g.bar+' a'); if(a) load(a.href,g.ids).catch(function(){}); };
      sec.addEventListener('pointerdown',warm,{passive:true}); sec.addEventListener('mouseover',warm,{passive:true}); sec.addEventListener('touchstart',warm,{passive:true});
      sec.addEventListener('click',function(e){
        var a=e.target.closest&&e.target.closest(g.bar+' a'); if(!a) return;
        if(e.metaKey||e.ctrlKey||e.shiftKey||e.altKey||e.button) return;
        var u=new URL(a.href,location.href); if(u.origin!==location.origin) return;
        e.preventDefault();
        var cur=document.querySelector(g.bar); cur&&cur.querySelectorAll('a').forEach(function(x){ x.classList.toggle('is-on',x===a); });
        var grid=document.getElementById('CollectionProductGrid'); if(grid) grid.style.opacity='.55';
        var href=a.href;
        load(href,g.ids).then(function(j){ swap(g,j,href,true); })
          .catch(function(){ location.href=href; });
      });
      /* im Leerlauf alle Einträge der Leiste vorladen (klein, gecacht) */
      var go=function(){ var links=[].slice.call(bar.querySelectorAll('a')).filter(function(x){return !x.classList.contains('is-on');}); var i=0; (function next(){ if(i>=links.length) return; load(links[i++].href,g.ids).catch(function(){}).then(function(){ setTimeout(next,150); }); })(); };
      setTimeout(go,300);
    });
  }
  window.addEventListener('popstate',function(){
    var g=groups()[0]; if(!g) return;
    load(location.href,g.ids).then(function(j){ swap(g,j,location.href,false); }).catch(function(){ location.reload(); });
  });
  if(document.readyState!=='loading') bind(); else document.addEventListener('DOMContentLoaded',bind);
})();

/* Duma 07.10: Sorte/Grösse sofort wechseln.
   - Varianten-Daten werden im Leerlauf nacheinander vorgeladen (statt erst beim Antippen, alle gleichzeitig)
   - doppelte Abrufe derselben Variante werden zusammengelegt
   - Preis springt sofort um, bevor der Rest nachgeladen ist */
(function(){
  if(!window.customElements||!customElements.whenDefined) return;
  var idle=window.requestIdleCallback||function(f){return setTimeout(f,200)};
  function seqPrefetch(el){
    if(!el||!el.dataCache) return;
    var urls=[].map.call(el.querySelectorAll('[data-product-variant]'),function(v){return v.getAttribute('data-product-fetch-url')})
      .filter(function(u,i,a){return u&&a.indexOf(u)===i&&!el.dataCache.has(u)});
    var i=0;(function next(){ if(i>=urls.length) return; var u=urls[i++]; Promise.resolve(el.fetchProductData(u)).catch(function(){}).then(function(){ idle(next); }); })();
  }
  customElements.whenDefined('product-information').then(function(){
    var C=customElements.get('product-information'); if(!C||C.prototype.__dmFast) return; var P=C.prototype; P.__dmFast=1;
    var orig=P.fetchProductData;
    P.fetchProductData=function(url){
      var self=this; self.__dmPend=self.__dmPend||{};
      if(self.dataCache&&self.dataCache.has(url)) return Promise.resolve();
      if(self.__dmPend[url]) return self.__dmPend[url];
      var p=Promise.resolve(orig.call(self,url)); self.__dmPend[url]=p;
      p.then(function(){delete self.__dmPend[url]},function(){delete self.__dmPend[url]});
      return p;
    };
    /* nur Bereiche neu aufbauen, die sich für die neue Variante wirklich ändern */
    var origRep=P.replaceElements;
    P.replaceElements=function(html,context){
      try{
        context=context||{};
        var pi=html&&html.querySelector('product-information[data-url="'+context.productURL+'"]');
        if(pi){
          var self=this; self.__dmLast=self.__dmLast||{};
          pi.querySelectorAll('[data-update-id]').forEach(function(n){
            var id=n.getAttribute('data-update-id'); if(n.hasAttribute('data-replace-content')) return;
            var cur=self.querySelector('[data-update-id="'+id+'"]'); if(!cur) return;
            var nh=n.innerHTML, prev=self.__dmLast[id];
            if((prev!==undefined&&prev===nh)||(prev===undefined&&cur.innerHTML===nh)){ n.removeAttribute('data-update-id'); n.setAttribute('data-dm-same',id); }
            else self.__dmLast[id]=nh;
          });
          /* entfernte IDs nicht als "neu" einfügen lassen: Platzhalter-Kopie der ID ausserhalb */
          var keep=[].slice.call(pi.querySelectorAll('[data-dm-same]'));
          var r=origRep.call(this,html,context);
          return r;
        }
      }catch(e){}
      return origRep.call(this,html,context);
    };
    function warm(){ document.querySelectorAll('product-information').forEach(function(el){ seqPrefetch(el); }); }
    var start=function(){ setTimeout(function(){ idle(warm); },1200); };
    if(document.readyState==='complete') start(); else window.addEventListener('load',start);
    if(window.eventBus&&eventBus.on){
      eventBus.on('variant:updated',function(){ setTimeout(function(){ idle(warm); },300); });
      eventBus.on('variant:change',function(ctx){
        try{
          var v=ctx&&ctx.variant; if(!v||typeof v.price!=='number') return;
          var root=document.querySelector('product-information[data-section-id="'+ctx.sectionId+'"]')||document;
          var s=root.querySelector('[data-product-price] [data-price-text]');
          var cur=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'CHF'; if(s&&/CHF|EUR/.test(s.textContent)){try{s.textContent=new Intl.NumberFormat('de-CH',{style:'currency',currency:cur}).format(v.price/100)}catch(e){s.textContent=cur+' '+(v.price/100).toFixed(2)}}
        }catch(e){}
      });
    }
  });
})();

/* Duma 07.10. (3): Kategorien-Leiste bleibt beim Scrollen oben sichtbar (Alle Produkte / Kategorien).
   Wechsel von dort: ohne Neuladen, danach direkt zu den Produkten – kein Zurückscrollen mehr nötig. */
(function(){
  var hero, bar, grid, ticking=false, wantScroll=false;
  function headerBottom(){
    var h=document.querySelector('.dm-header, header.site-header, .header-section, #shopify-section-header, [id$="__dm_header"]');
    if(!h) return 0; var r=h.getBoundingClientRect(); return Math.max(0, Math.min(r.bottom, 140));
  }
  function build(){
    hero=document.querySelector('.dm-colhero2__chips'); grid=document.getElementById('CollectionProductGrid');
    if(!hero||!grid){ if(bar) bar.classList.remove('is-on'); return; }
    if(!bar){ bar=document.createElement('nav'); bar.className='dm-catbar'; bar.setAttribute('aria-label','Kategorien'); document.body.appendChild(bar);
      bar.addEventListener('click',function(e){
        var a=e.target.closest('a'); if(!a) return; if(e.metaKey||e.ctrlKey||e.shiftKey||e.altKey) return;
        var src=[].slice.call(document.querySelectorAll('.dm-colhero2__chips a')).find(function(x){return x.getAttribute('href')===a.getAttribute('href');});
        if(!src) return; e.preventDefault(); wantScroll=true;
        bar.querySelectorAll('a').forEach(function(x){x.classList.toggle('is-on',x===a);});
        src.click();
      });
    }
    var sl=bar.scrollLeft; bar.innerHTML=hero.innerHTML; bar.scrollLeft=sl;
    var on=bar.querySelector('.is-on'); if(on){ var l=bar.scrollLeft+(on.getBoundingClientRect().left-bar.getBoundingClientRect().left)-(bar.clientWidth-on.offsetWidth)/2; bar.scrollLeft=Math.max(0,l); }
    upd();
  }
  function upd(){
    ticking=false; if(!bar||!hero||!grid) return;
    var hb=headerBottom(); bar.style.top=hb+'px';
    var show=hero.getBoundingClientRect().bottom<hb && grid.getBoundingClientRect().bottom>hb+120;
    if(bar.classList.contains('is-on')!==show) bar.classList.toggle('is-on',show);
  }
  document.addEventListener('dm:softnav',function(){
    build();
    if(wantScroll){ wantScroll=false; grid=document.getElementById('CollectionProductGrid'); var sec=grid&&grid.closest('[id^="shopify-section-"]'); if(sec){ var y=sec.getBoundingClientRect().top+window.scrollY-headerBottom()-(bar?bar.offsetHeight:0)-4; window.scrollTo(0,Math.max(0,y)); } setTimeout(upd,50); }
  });
  window.addEventListener('scroll',function(){ if(!ticking){ ticking=true; requestAnimationFrame(upd); } },{passive:true});
  window.addEventListener('resize',upd);
  if(document.readyState!=='loading') build(); else document.addEventListener('DOMContentLoaded',build);
})();

/* Duma 07.10. (3): Express-Kauf (Shop Pay, Google Pay, Apple Pay) im Warenkorb – erst beim Öffnen nachladen, damit keine Seite langsamer wird */
(function(){
  var node=null, loading=null;
  function drawerOpen(){ var d=document.querySelector('cart-drawer'); return !!d && d.getAttribute('aria-hidden')==='false'; }
  function place(){
    var box=document.querySelector('cart-drawer [data-dm-xpay]'); if(!box||!node) return;
    if(box.getAttribute('data-dm-sub')==='1'){ box.hidden=true; return; }
    var slot=box.querySelector('[data-dm-xpay-slot]'); if(!slot) return;
    if(node.parentNode!==slot){ slot.innerHTML=''; slot.appendChild(node); }
    box.hidden=false;
  }
  function load(){
    if(node){ place(); return; }
    var bx=document.querySelector('cart-drawer [data-dm-xpay]');
    if(loading||!bx||bx.getAttribute('data-dm-sub')==='1') return;
    loading=fetch('/cart?view=dm-xpay',{credentials:'same-origin'}).then(function(r){return r.ok?r.text():''}).then(function(h){
      var t=document.createElement('div'); t.innerHTML=h; var n=t.querySelector('.dm-xpay-src');
      if(n&&n.querySelector('shopify-accelerated-checkout-cart, .dynamic-checkout__content')&&!/wiederkehrend|Zahlungsaufschub/i.test(n.textContent)){ node=n; place(); }
    }).catch(function(){}).then(function(){ loading=null; });
  }
  function check(){
    var bx=document.querySelector('cart-drawer [data-dm-xpay]');
    if(bx && !node && bx.getAttribute('data-dm-sub')!=='1' && !bx.dataset.dmWait){ bx.dataset.dmWait='1'; bx.hidden=false; setTimeout(function(){ var b=document.querySelector('cart-drawer [data-dm-xpay]'); if(b && !node){ b.hidden=true; } },8000); }
    if(drawerOpen()) load(); else if(node) place();
  }
  function init(){
    var cd=document.querySelector('cart-drawer'); if(!cd) return;
    var q=false; new MutationObserver(function(){ if(q) return; q=true; requestAnimationFrame(function(){ q=false; check(); }); }).observe(cd,{childList:true,subtree:true,attributes:true,attributeFilter:['aria-hidden']});
    check();
    /* Duma 20.10.: Express-Knöpfe im Hintergrund vorladen (nach dem Laden der Seite, im Leerlauf), damit sie beim Öffnen des Warenkorbs sofort da sind */
    var ic=window.requestIdleCallback||function(f){ return setTimeout(f,1); };
    /* Duma 21.10.: früher vorladen (Leerlauf nach dem Laden, spätestens 1.5 s) und sofort beim Antippen von «In den Warenkorb» oder dem Warenkorb-Symbol */
    window.addEventListener('load',function(){ if(window.requestIdleCallback) requestIdleCallback(load,{timeout:1500}); else setTimeout(load,300); });
    document.addEventListener('pointerdown',function(e){ if(e.target.closest && e.target.closest('button[name="add"], [data-dm-add], .dm-sets__b, [data-dm-cart], .dm-packs__tip, .cart-drawer__recommendations button')) load(); },{passive:true,capture:true});
  }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded',init);
})();

/* Duma 09.10.: Bundles im Warenkorb – getrennte Sorten-Auswahlen ergeben die passende Variante */
(function(){
  function pick(form){
    var data; try{ data=JSON.parse(form.querySelector('[data-dm-variants]').textContent); }catch(e){ return; }
    var sels=form.querySelectorAll('[data-dm-opt]'), want=[], done=true;
    sels.forEach(function(s){ var i=+s.getAttribute('data-dm-opt'); want[i]=s.value; if(!s.value) done=false; });
    var inp=form.querySelector('[data-dm-vid]'), na=form.querySelector('.dm-pcb-na'), btn=form.querySelector('button[type=submit]');
    if(!done){ inp.value=''; if(na) na.hidden=true; if(btn) btn.disabled=false; return; }
    var v=data.filter(function(x){ return x.o.every(function(val,i){ return val===want[i]; }); })[0];
    inp.value = v && v.a ? v.id : '';
    if(na) na.hidden = !!(v && v.a);
    if(btn) btn.disabled = !(v && v.a);
  }
  /* Duma 21.10.: sobald alle Sorten gewählt sind, direkt hinzufügen (kein zweiter Klick) */
  function auto(form){ var b=form.querySelector('button[type=submit]'); if(b && !b.disabled && !b.classList.contains('is-loading')) setTimeout(function(){ b.click(); },120); }
  document.addEventListener('change',function(e){ var s=e.target; if(!s.matches) return;
    if(s.matches('.dm-pcb-multi [data-dm-opt]')){ var f=s.closest('form'); pick(f); if(f.querySelector('[data-dm-vid]').value) auto(f); }
    else if(s.matches('.dm-pcb-form:not(.dm-pcb-multi) select[name=id]') && s.value){ auto(s.closest('form')); } });
  document.addEventListener('submit',function(e){ var f=e.target; if(f.classList && f.classList.contains('dm-pcb-multi')){ pick(f); if(!f.querySelector('[data-dm-vid]').value){ e.preventDefault(); e.stopImmediatePropagation(); } } },true);
})();

/* Duma 09.10.: «Passt perfekt dazu» – Sorten erst nach Klick einblenden (spart Platz, kein Seitenwechsel, keine Ladezeit) */
(function(){
  document.addEventListener('click',function(e){ var bt=e.target.closest && e.target.closest('.dm-pcb-closed button[type=submit]'); var f=bt && bt.form; if(f && f.classList.contains('dm-pcb-closed')){ e.preventDefault(); e.stopImmediatePropagation(); f.classList.remove('dm-pcb-closed'); var rc=f.closest('.cart-drawer__recommendations'); if(rc){ rc.style.height='auto'; var hh=rc.getBoundingClientRect().height; rc.style.height=''; document.documentElement.style.setProperty('--cart-recommendations-height', hh+'px'); } var s=f.querySelector('select:not([disabled])'); if(s){ try{ s.focus({preventScroll:true}); }catch(x){} } } },true);
})();

/* Duma 20.10. Variante 3: Zähler neben «In den Warenkorb», verbunden mit der Mengenstaffel (1/2/3 oben = Zähler; ab 4 ist oben nichts markiert) */
(function () {
  function init() {
    document.querySelectorAll("[data-dm-packs]").forEach(function (box) {
      if (box._dmStep) return;
      var sec = box.closest("product-information") || box.closest(".shopify-section"); if (!sec) return;
      var form = sec.querySelector('product-form form[action*="/cart/add"]') || sec.querySelector('form[data-type="add-to-cart-form"]'); if (!form) return;
      var atc = form.querySelector('button[name="add"]'); if (!atc || atc.closest(".dm-atcrow")) return;
      box._dmStep = 1; box.classList.add("dm-has-step");
      var more = box.querySelector("[data-qty-more]"), num = more && more.querySelector("input");
      var opts = [].slice.call(box.querySelectorAll(".dm-packs__opt[data-qty]"));
      var row = document.createElement("div"); row.className = "dm-atcrow";
      var st = document.createElement("div"); st.className = "dm-atcqty";
      st.innerHTML = '<button type="button" aria-label="Weniger">−</button><span aria-live="polite">1</span><button type="button" aria-label="Mehr">+</button>';
      atc.parentNode.insertBefore(row, atc); row.appendChild(st); row.appendChild(atc);
      var out = st.querySelector("span");
      function cur() {
        if (more && num && more.classList.contains("is-on")) return Math.max(parseInt(num.min, 10) || 4, parseInt(num.value, 10) || 4);
        var on = box.querySelector(".dm-packs__opt.is-on"); if (!on) return 1;
        return Number(on.getAttribute("data-qty")) || 1;
      }
      function show() { out.textContent = cur(); }
      function setN(n) {
        n = Math.max(1, Math.min(99, n));
        var o = opts.filter(function (x) { return Number(x.getAttribute("data-qty")) === n; })[0];
        box.classList.add("dm-step-used"); box._dmFromStep = true;  /* Spar-Tipp nicht einblenden, sonst rutscht der Zähler unter dem Finger weg */
        if (o) { o.click(); } else if (more && num) { num.value = n; num.dispatchEvent(new Event("change", { bubbles: true })); }
        box._dmFromStep = false;
        show();
      }
      st.children[0].addEventListener("click", function () { setN(cur() - 1); });
      st.children[2].addEventListener("click", function () { setN(cur() + 1); });
      box.addEventListener("click", function () { if (!box._dmFromStep) box.classList.remove("dm-step-used"); setTimeout(show, 0); }, true);
      box.addEventListener("change", function () { setTimeout(show, 0); });
      show();
    });
  }
  /* Produkte ohne Mengenstaffel (Sets, 3er-Packs, Bundles): Shop-Zähler ebenfalls neben den Knopf */
  function initPlain() {
    document.querySelectorAll('product-form form[action*="/cart/add"]').forEach(function (form) {
      var atc = form.querySelector('button[name="add"]'); if (!atc || atc.closest(".dm-atcrow")) return;
      var sec = form.closest("product-information") || form.closest(".shopify-section"); if (!sec || sec.querySelector("[data-dm-packs]")) return;
      var qi = sec.querySelector("quantity-input"); if (!qi || qi.closest(".dm-atcrow")) return;
      var row = document.createElement("div"); row.className = "dm-atcrow";
      atc.parentNode.insertBefore(row, atc); row.appendChild(qi); row.appendChild(atc); qi.classList.add("dm-atcqi");
    });
  }
  function all() { init(); initPlain(); }
  if (document.readyState !== "loading") all(); else document.addEventListener("DOMContentLoaded", all);
  setInterval(all, 1200);
  /* Duma 21.10.: Schnellansicht – sofort umbauen, sobald sie eingefügt wird (nicht erst nach bis zu 1.2 s) → kein Springen */
  var dmQ=false; new MutationObserver(function(ms){ if(dmQ) return; for(var i=0;i<ms.length;i++){ if(ms[i].addedNodes.length){ dmQ=true; requestAnimationFrame(function(){ dmQ=false; all(); }); return; } } }).observe(document.documentElement,{childList:true,subtree:true});
})();
/* Duma 20.10. Variante 3: Abo als ein Feld (an/aus). Wir setzen Appstles eigene Auswahl-Felder und melden die Änderung,
   so bleibt Appstle immer im richtigen Zustand, auch nach einem Mengenwechsel. */
document.addEventListener("click", function (e) {
  var w = e.target.closest && e.target.closest(".appstle_sub_widget .appstle_subscription_radio_wrapper"); if (!w) return;
  var wid = w.closest(".appstle_sub_widget"), opt = w.closest(".appstle_subscription_wrapper_option");
  var o = wid.querySelector(".appstle_one_time_details_wrapper input[type=radio]"), s = w.querySelector("input[type=radio]");
  if (!o || !s || !opt) return;
  if (!opt.classList.contains("appstle-active-option")) return; /* Einschalten: Appstles eigener Klick */
  e.preventDefault(); e.stopPropagation();                      /* Ausschalten: Appstles Einmalkauf-Feld anklicken, */
  var ol = wid.querySelector(".appstle_one_time_details_wrapper label");  /* kurz nach diesem Klick, sonst ignoriert der Browser es */
  setTimeout(function () { (ol || o).dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true, view: window })); }, 0);
}, true);

/* Duma 20.10. Schnellansicht: Grösse neben «Health Line» aus der gewählten Sorte/Grösse im Fenster setzen */
(function () {
  function qv() {
    document.querySelectorAll(".right-drawer-vue .dm-qv").forEach(function (q) { var g = q.querySelector(".dm-gtags"); if (g && g.parentElement !== q) { q.insertBefore(g, q.firstChild); g.classList.add("dm-gtags--qv"); } });
    document.querySelectorAll(".right-drawer-vue .dm-buy-intro__lede").forEach(function (p) {  /* «Mehr lesen» wie auf der Produktseite */
      if (p.dataset.dmMore) return; p.dataset.dmMore = "1";
      var box = p.closest(".dm-buy-intro"), mix = box && box.querySelector(".dm-buy-intro__mix");
      if (box) box.classList.add("dm-qv-intro");
      if (p.scrollHeight <= p.clientHeight + 2) return;  /* 21.10.: Set-Inhalt mit Grössen bleibt immer sichtbar, nur der Text klappt */
      var b = document.createElement("button"); b.type = "button"; b.className = "dm-buy-intro__more"; b.textContent = "Mehr lesen";
      b.addEventListener("click", function () { var o = p.classList.toggle("is-open"); if (box) box.classList.toggle("is-open", o); b.textContent = o ? "Weniger" : "Mehr lesen"; });
      p.insertAdjacentElement("afterend", b);
    });
    document.querySelectorAll(".right-drawer-vue").forEach(function (d) {
      var bs = d.querySelectorAll("[data-dm-vbadge]"); if (!bs.length) return;
      var txt = [].map.call(d.querySelectorAll("input[type=radio]:checked"), function (r) { return r.value; }).join(" ");
      var sel = d.querySelector('form[action*="/cart/add"] select[name="id"]'); if (sel && sel.options[sel.selectedIndex]) txt += " " + sel.options[sel.selectedIndex].text;
      txt = txt.replace(/\s/g, "");
      var hit = [].some.call(bs, function (b) { return txt.indexOf(b.getAttribute("data-dm-vbadge")) > -1; }); if (!hit) return;
      bs.forEach(function (b) { b.hidden = txt.indexOf(b.getAttribute("data-dm-vbadge")) < 0; });
    });
  }
  document.addEventListener("change", function (e) { if (e.target.closest && e.target.closest(".right-drawer-vue")) { setTimeout(qv, 80); setTimeout(qv, 400); } });
  document.addEventListener("click", function (e) { if (e.target.closest && e.target.closest(".dm-tile__qv,[data-dm-qv],.right-drawer-vue")) { [300, 600, 1000, 1500, 3000].forEach(function (t) { setTimeout(qv, t); }); } });
})();

/* Duma 21.10.: /cart öffnet kein seitliches Fenster mehr (PC und Handy). Wer direkt auf /cart kommt
   (Warenkorb-Mails, Zurück aus der Kasse), sieht nur die Warenkorb-Seite im neuen Design. Symbol und
   «In den Warenkorb» öffnen weiterhin nur das seitliche Fenster. */

/* Duma 21.10. Schnellansicht: Kaufleiste wie am Handy (nur sichtbar, wenn der Kaufbereich nicht im Bild ist), doppelte Mengenwahl entfernen */
(function () {
  function upd() {
    document.querySelectorAll(".right-drawer-vue .dm-qv").forEach(function (q) {
      var bar = q.querySelector(".dm-qv-bar"), row = q.querySelector(".dm-atcrow"); if (!bar || !row) return;
      var r = row.getBoundingClientRect(), vh = window.innerHeight;
      bar.classList.toggle("dm-qv-bar--on", !(r.bottom > 0 && r.top < vh - bar.offsetHeight));
      var form = row.closest("form") || q;
      q.querySelectorAll("quantity-input").forEach(function (qi) { if (!qi.closest(".dm-atcrow") && form.contains(qi)) qi.style.display = "none"; });
    });
  }
  document.addEventListener("scroll", upd, true);
  window.addEventListener("resize", upd);
  document.addEventListener("click", function (e) { if (e.target.closest && e.target.closest(".dm-tile__qv,[data-dm-qv],.right-drawer-vue")) [300, 800, 1500, 3000].forEach(function (t) { setTimeout(upd, t); }); });
})();

/* Duma 21.10. Mikronährstoffberatung: keine eigene Produktseite – Verkauf läuft über die Coaching-Seite */
(function () { if (/\/products\/mikronahrstoffberatung\/?$/.test(location.pathname)) location.replace("/pages/duma-performance-coaching"); })();

/* Duma 21.10. Sets/Bundles: Grösse in der Sorten-Überschrift, z.B. «100% Swiss Whey Protein 900g · Geschmack» (Produktseite + Schnellansicht) */
(function () {
  /* 21.10. Bella: Grösse steht schon im Set-Inhalt oben, hier nicht nochmals */
  var SIZE = {};
  function run() {
    document.querySelectorAll("product-swatch .option-label-wrapper .header").forEach(function (h) {
      if (h.dataset.dmSize) return;
      var m = h.textContent.trim().match(/^(.*?)\s*\((Geschmack|Farbe)\)$/); if (!m) return;
      var name = m[1].replace(/’/g, "'"), sz = SIZE[name] ? " " + SIZE[name] : "";
      h.textContent = name; if (sz) { var g = document.createElement("span"); g.style.textTransform = "none"; g.textContent = sz; h.appendChild(g); } h.appendChild(document.createTextNode(" · " + m[2])); h.dataset.dmSize = "1";
    });
  }
  /* Mengen wie «900g» / «500ml» in Grossbuchstaben-Überschriften klein lassen (Set-Inhalt) */
  function units() {
    document.querySelectorAll(".dm-buy-intro__mix b:not([data-dm-u])").forEach(function (b) {
      b.dataset.dmU = "1";
      b.innerHTML = b.innerHTML.replace(/(\d+(?:[.,]\d+)?\s?(?:g|kg|ml)\b)/g, '<span style="text-transform:none">$1</span>');
    });
  }
  var run0 = run; run = function () { run0(); units(); };
  if (document.readyState !== "loading") run(); else document.addEventListener("DOMContentLoaded", run);
  document.addEventListener("click", function (e) { if (e.target.closest && e.target.closest(".dm-tile__qv,[data-dm-qv],.right-drawer-vue,product-swatch")) [300, 800, 1500, 3000].forEach(function (t) { setTimeout(run, t); }); });
  document.addEventListener("change", function () { setTimeout(run, 100); setTimeout(run, 600); });
})();


/* Duma 21.10. Tempo: Gratisversand-Balken gleich nach dem Hinzufügen nachführen statt erst nach dem Neuaufbau des Warenkorbs */
(function () {
  if (window.fetch && !window.dmFetchHook) {
    window.dmFetchHook = 1;
    var of = window.fetch;
    window.fetch = function (u) {
      var p = of.apply(this, arguments);
      try {
        var url = typeof u === "string" ? u : (u && u.url) || "";
        if (/\/cart\/(add|change|update|clear)/.test(url) && typeof window.updateShippingThreshold === "function") p.then(function () { window.updateShippingThreshold(); }, function () {});
      } catch (e) {}
      return p;
    };
  }
})();

/* Duma 21.10.: Warenkorb-Seite – wird über «Passt perfekt dazu» oder die Schnellansicht ein neuer Artikel hinzugefügt,
   lädt die Seite neu, damit Artikel, Summe und Gratisversand sofort stimmen (kein seitliches Fenster). */
(function(){
  if(!document.body||!document.body.classList.contains('template-cart')) return;
  function hook(){
    if(!window.eventBus||!window.eventBus.on) return setTimeout(hook,200);
    window.eventBus.on('update:cart:drawer',function(){
      fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
        var rows=document.querySelectorAll('.cart-table tbody tr.cart__row').length;
        if(c.items.length!==rows) location.reload();
      });
    });
  }
  hook();
})();

/* Duma 21.10.: Warenkorb-Seite – Menge (+ / − / Eingabe) wird sofort gespeichert, danach lädt die Seite neu
   (Summe und Gratisversand stimmen sofort, wie im seitlichen Fenster; kein seitliches Fenster). */
(function(){
  if(!document.body||!document.body.classList.contains('template-cart')) return;
  var form=document.querySelector('.template-cart form.cart'); if(!form) return;
  var t=null, busy=false;
  function save(){
    if(busy) return; busy=true;
    var fd=new FormData(); form.querySelectorAll('input[name^="updates"]').forEach(function(i){fd.append(i.name,i.value);});
    form.classList.add('dm-cart-saving');
    fetch('/cart/update.js',{method:'POST',body:fd,headers:{'Accept':'application/json'}}).then(function(){location.reload();}).catch(function(){busy=false;form.classList.remove('dm-cart-saving');});
  }
  function later(){clearTimeout(t);t=setTimeout(save,600);}
  form.addEventListener('click',function(e){if(e.target.closest('.js-qty__adjust')) setTimeout(later,0);});
  form.addEventListener('change',function(e){if(e.target.matches('input[name^="updates"]')) later();});
})();

/* Duma 21.10.: Warenkorb-Seite am Handy – fixierte Leiste «Zur Kasse» mit Zwischensumme (wie die Kaufleiste auf der
   Produktseite). Sie blendet sich aus, sobald die Zusammenfassung mit «Zur Kasse» im Bild ist. */
(function(){
  if(!document.body||!document.body.classList.contains('template-cart')) return;
  var box=document.querySelector('.template-cart form.cart>.grid.cart__row'), btn=box&&box.querySelector('.cart--button-checkout');
  var tot=box&&box.querySelector('p .cart__subtotal .money');
  if(!box||!btn||!tot||!('IntersectionObserver' in window)) return;
  var bar=document.createElement('div'); bar.className='dm-ckbar'; bar.setAttribute('aria-hidden','true');
  bar.innerHTML='<div class="dm-ckbar__sum"><small>Zwischensumme</small><strong></strong></div><button type="button" class="dm-ckbar__btn" tabindex="-1">Zur Kasse</button>';
  bar.querySelector('strong').textContent=tot.textContent.trim();
  bar.querySelector('button').addEventListener('click',function(){btn.click();});
  document.body.appendChild(bar);
  new IntersectionObserver(function(en){
    var e=en[0]; var show=!e.isIntersecting && e.boundingClientRect.top>0;
    bar.classList.toggle('is-on',show);
  },{threshold:0}).observe(btn);
})();

/* Duma 21.10.: Auf der Warenkorb-Seite öffnet das Warenkorb-Symbol oben kein seitliches Fenster – es scrollt nur nach oben zu den Artikeln */
(function(){
  if(!document.body||!document.body.classList.contains('template-cart')) return;
  document.addEventListener('click',function(e){
    var a=e.target.closest&&e.target.closest('[data-dm-cart], a[href="/cart"], a[href$="/cart"]'); if(!a) return;
    if(a.closest('form.cart')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    window.scrollTo({top:0,behavior:'smooth'});
  },true);
})();
